define(function(require) {
    // GEO03E07_CP_REFRN layer definition config

    function _createDateValue(key, obj) {
        return obj[key] ? new Date(obj[key]).toLocaleDateString("fr-CA") : null;
    };

    return {
        LAYER_ID : "GEO03E07_CP_REFRN",
        LAYER_TYPE : "POINT",
        LOADING_MODE : "ON_DEMAND",
        QUERY_EXPRESSION : {
            LOGICAL_OPERATOR : null,
            QUERIES : [{FIELD : undefined, OPERATOR : "IN", VALUE : undefined}]
        },
        INDEX : 46,
        DATATABLE_ID : "t_GEO03E07_CP_REFRN",
        QUERY_FIELDS : ["CD_POSTL", "DT_CRETN_CD_POSTL", "DT_RETRT_CD_POSTL", "CD_SECTR_FRA", "CD_SECTR_ANG", "CD_SECTR_STA", "CD_SECTR_FRA", "CD_MUNCP", "NOM_MUNCP"],
        FIELDS : [
            {ID : "ID", NAME : "Id", DATA_TYPE : "STRING", VALUE : "{{$UUID$}}"},
            {ID : "CD_POSTL", NAME : "Code postal", DATA_TYPE : "STRING", VALUE : "{{CD_POSTL}}"},
            {ID : "DT_CRETN_CD_POSTL", NAME : "Date de création", DATA_TYPE : "DATE_TIME", VALUE : _createDateValue.bind(this, "DT_CRETN_CD_POSTL")},
            {ID : "DT_RETRT_CD_POSTL", NAME : "Date retrait", DATA_TYPE : "DATE_TIME", VALUE : _createDateValue.bind(this, "DT_RETRT_CD_POSTL")},
            {ID : "CD_SECTR_FRA", NAME : "Code secteur francophone", DATA_TYPE : "STRING", VALUE : "{{CD_SECTR_FRA}}"},
            {ID : "CD_SECTR_ANG", NAME : "Code secteur anglophone", DATA_TYPE : "STRING", VALUE : "{{CD_SECTR_ANG}}"},
            {ID : "CD_SECTR_STA", NAME : "Code secteur statut particulier", DATA_TYPE : "STRING", VALUE : "{{CD_SECTR_STA}}"},
            {ID : "CD_SECTR_FRA", NAME : "Code secteur francophone", DATA_TYPE : "STRING", VALUE : "{{CD_SECTR_FRA}}"},
            {ID : "CD_MUNCP", NAME : "Code de municipalité", DATA_TYPE : "STRING", VALUE : "{{CD_MUNCP}}"},
            {ID : "NOM_MUNCP", NAME : "Nom de municipalité", DATA_TYPE : "STRING", VALUE : "{{NOM_MUNCP}}"}
        ],
        STYLES : [
            {
                ID : "Codes postaux",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                        COLOR : "rgba(255,255,255,1)",
                        FONT_NAME : "CartoVistaCartographic",
                        FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                        SYMBOL_CHAR : ")",
                        SIZE : 16,
                        HAS_HALO : true,
                        HALO_COLOR : "rgba(0,0,0,1)"
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Codes postaux recherchés",
            FEATURE_ID_DATACOLUMN : "ID",
            FEATURE_NAME_DATACOLUMN : "CD_POSTL",
            DATATIP_DATACOLUMNS : ["CD_POSTL", "DT_CRETN_CD_POSTL", "DT_RETRT_CD_POSTL"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_POSTL", "DT_CRETN_CD_POSTL", "DT_RETRT_CD_POSTL", "CD_SECTR_FRA", "CD_SECTR_ANG", "CD_SECTR_STA", "CD_MUNCP", "NOM_MUNCP"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_POSTL", "DT_CRETN_CD_POSTL", "DT_RETRT_CD_POSTL", "CD_SECTR_FRA", "CD_SECTR_ANG", "CD_SECTR_STA", "CD_MUNCP", "NOM_MUNCP"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_POSTL"],
            IS_VISIBLE_IN_LAYER_CONTROL : false,
            IS_VISIBLE_IN_LEGEND : false,
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "CD_POSTL",
            LABEL_PROPERTIES : {
                LEADER_LINES : false,
                POSITION : "MIDDLE-RIGHT",
                OFFSET_X : 2,
                PRIORITY : 5
            },
            VISIBLE : true,
            ZOOM_ON_FEATURE_SCALE : 6000
        }
    };
});
